"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function HeroBanner() {
  const tabs = ["Visti Lavoro", "Immigrazione", "Consulenza", "Documenti", "Legalizzazioni", "Traduzioni", "Apostille", "Relocation", "Supporto"];
  return <section data-section-id="252227" id="herotitle" className="relative w-full min-h-[80vh] flex flex-col items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/corporate_business_travel_visa.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/corporate_business_travel_visa.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/corporate_business_travel_visa.png-wvc-sizes" alt="Professional Business Mobility" className="w-full h-full object-cover" loading="lazy" decoding="async" />
        <div className="absolute inset-0 bg-primary/60 backdrop-blur-[2px]"></div>
      </div>

      {}
      <div className="absolute top-0 left-0 w-full flex justify-between items-start z-10">
        <Link to="/">
          <img src="/img/visa_consulting_logo_gold.png" alt="Visa Consulting Logo" className="w-24 md:w-32 lg:w-40 h-auto" />
        </Link>
        <div className="hidden md:flex gap-6 items-center p-6 pr-8">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/certification_iso_quality.png" alt="ISO Quality Certification" className="h-10 lg:h-12 w-auto" />
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/global_mobility_award.png" alt="Global Mobility Excellence" className="h-16 lg:h-20 w-auto" />
        </div>
      </div>

      {}
      <div className="relative z-10 text-center px-4 flex flex-col items-center mt-20 md:mt-0 w-full max-w-4xl mx-auto">
        <h1 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold text-primary-foreground leading-tight mb-8 tracking-tight">
          Visti per
          <br />
          Lavoro
        </h1>
        <p className="font-default text-lg md:text-xl text-primary-foreground/90 mb-8 max-w-2xl">
          Soluzioni su misura per professionisti e dirigenti. Gestione completa delle procedure burocratiche per una mobilità internazionale organizzata e sicura.
        </p>
        <Button size="lg" className="rounded-md bg-[#FFC829] hover:bg-[#FFC829]/90 text-primary px-8 py-7 text-lg font-semibold shadow-lg">
          Richiedi una Consulenza
        </Button>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full flex justify-center z-20 px-4 md:px-8">
        <div className="bg-card w-full max-w-6xl rounded-t-md shadow-xl flex items-center overflow-x-auto hide-scrollbar border-b-0 border border-border/50">
          <div className="flex items-center gap-2 md:gap-4 p-4 md:p-6 min-w-max mx-auto">
            {tabs.map((tab, i) => <div key={i} data-index={i}>
                <Button variant={i === 0 ? "outline" : "ghost"} size="sm" className="px-5 py-2 rounded-md text-sm md:text-base font-medium whitespace-nowrap text-foreground hover:text-secondary">
                  {tab}
                  {tab === "Supporto" && <span className="ml-1 text-[10px] text-secondary font-bold align-top uppercase">
                      24/7
                    </span>}
                </Button>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}